import React, {Fragment} from 'react'
import './Badge.css'

export default (props) => (
  <Fragment>
    { props.onClick ?
      <button
        className="badge"
        onClick={props.onClick}
        style={{
          background: props.background ? props.background : "#fafafa",
          color: props.color ? props.color : "#fafafa",
        }}
      >
        {props.text} 
      </button>
    :
      <span
        className="badge"
        style={{
          background: props.background ? props.background : "#fafafa",
          color: props.color ? props.color : "#fafafa",
        }}
      >
        {props.text} 
      </span>
    }
  </Fragment>
)


// WEBPACK FOOTER //
// ./src/components/Badge/Badge.js